import { Fill } from "nano-slots";
import * as React from "react";
import { UNSAFE_RouteContext as RouteContext } from "react-router";

/* GlobalContextFill is here to forward the routing context to all the app parts and be sure that our 
   relative links will work, example here https://github.com/Clovis-team/clovis-app/blob/87f5f8dd21bac2a57c2ca2e6f614da8337cb797f/packages/client/src/screens/App/screens/Project/Project.tsx#L94-L100
   here you can see that when we declare routes, it is relative to above routes in the context avec react-router,
   si on <Project /> we don't need to precise the full url path
   Note that this GlobalContext can potentially provide other contexts than just routing 
   */
const GlobalContextFill = (
  props: React.ComponentProps<typeof Fill> & {
    children: React.ReactElement;
  }
) => {
  const contextValue = React.useContext(RouteContext);
  const { children, ...rest } = props;

  return (
    <Fill {...rest}>
      <RouteContext.Provider value={contextValue}>
        {children}
      </RouteContext.Provider>
    </Fill>
  );
};

type ScreenProps = {
  actions?: React.ReactElement;
  extraActions?: React.ReactElement;
  children: React.ReactNode;
  navigation?: React.ReactElement;
  primaryAction?: React.ReactElement;
  tabs?: React.ReactElement;
  title?: string;
  banner?: React.ReactElement;
};

function Screen(props: ScreenProps) {
  return (
    <div style={{ height: "100%" }}>
      {props.banner && (
        <GlobalContextFill name="Layout.Banner">
          {props.banner}
        </GlobalContextFill>
      )}
      {props.tabs && (
        <GlobalContextFill name="Layout.Tabs">{props.tabs}</GlobalContextFill>
      )}
      {props.primaryAction && (
        <GlobalContextFill name="Layout.PrimaryAction">
          {props.primaryAction}
        </GlobalContextFill>
      )}
      {props.actions && (
        <GlobalContextFill name="Layout.Actions">
          {props.actions}
        </GlobalContextFill>
      )}
      {props.extraActions && (
        <GlobalContextFill name="Layout.ExtraActions">
          {props.extraActions}
        </GlobalContextFill>
      )}
      {props.navigation && (
        <GlobalContextFill name="Layout.Navigation">
          {props.navigation}
        </GlobalContextFill>
      )}
      {props.children}
    </div>
  );
}

export type { ScreenProps };
export { GlobalContextFill, Screen };
